export default __webpack_public_path__ + "static/media/bannerBg.acb1f9ac.png";